import messages_en from "@/i18n/en/messages_en";
import messages_sk from "@/i18n/sk/messages_sk";

const messages = {
    en: messages_en,
    sk: messages_sk
}

export default messages